import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";

type ApiVersionType = "v1" | "v2";

const BASE_URL = process.env.NEXT_PUBLIC_AUTH_API_BASE_URL;

export default class AuthBaseApi {
  client: AxiosInstance;

  constructor(baseUrl: string, version: ApiVersionType = "v1") {
    this.client = axios.create({
      baseURL: `${BASE_URL}/${version}${baseUrl}`,
    });
  }

  addAuthHeader(config?: AxiosRequestConfig) {
    return config || {};
  }

  private handleError(error: unknown): never {
    const { response } = error as AxiosError<any>;

    throw error;
  }

  async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    try {
      const result = await this.client.get<T>(url, this.addAuthHeader(config));
      return result.data;
    } catch (error) {
      return Promise.reject(this.handleError(error));
    }
  }

  async put<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<T> {
    try {
      const result = await this.client.put<T>(
        url,
        data,
        this.addAuthHeader(config),
      );
      return result.data;
    } catch (error) {
      return Promise.reject(this.handleError(error));
    }
  }

  async post<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<T> {
    try {
      const result = await this.client.post<T>(
        url,
        data,
        this.addAuthHeader(config),
      );
      return result.data;
    } catch (error) {
      return Promise.reject(this.handleError(error));
    }
  }

  async patch<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<T> {
    try {
      const result = await this.client.patch<T>(
        url,
        data,
        this.addAuthHeader(config),
      );
      return result.data;
    } catch (error) {
      return Promise.reject(this.handleError(error));
    }
  }

  async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    try {
      const result = await this.client.delete<T>(
        url,
        this.addAuthHeader(config),
      );
      return result.data;
    } catch (error) {
      return Promise.reject(this.handleError(error));
    }
  }
}
